import { render, staticRenderFns } from "./GameYouTube.vue?vue&type=template&id=afc1571e&"
import script from "./GameYouTube.vue?vue&type=script&lang=js&"
export * from "./GameYouTube.vue?vue&type=script&lang=js&"
import style0 from "./GameYouTube.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc1571e')) {
      api.createRecord('afc1571e', component.options)
    } else {
      api.reload('afc1571e', component.options)
    }
    module.hot.accept("./GameYouTube.vue?vue&type=template&id=afc1571e&", function () {
      api.rerender('afc1571e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameYouTube.vue"
export default component.exports